import React from 'react';
import SearchInput from '../SearchInput';
import AddButton from './AddButton';
import './SearchAddCont.scss';
import { useTranslation } from 'react-i18next';

function SearchAddCont({
  isLoading,
  onAdd,
  addLabel,
  onFilter,
  query,
  pathname,
}) {
  const [t] = useTranslation('COMMON');
  return (
    <div className="row search-add-cont">
      <div
        className="col-sm-12 col-md-6 col-lg-8"
        style={{ marginBottom: '10px' }}
      >
        <SearchInput onFilter={onFilter} query={query} label={t('SEARCH')} />
      </div>
      {pathname === 'profiles' && (
        <div className="col-sm-12 col-md-6 col-lg-4">
          <AddButton isLoading={isLoading} onAdd={onAdd} addLabel={addLabel} />
        </div>
      )}
    </div>
  );
}

export default SearchAddCont;
